import { useState } from "react";
import { Link } from "react-router-dom";
import { Send, ArrowLeft } from "lucide-react";
import { submitSupport } from "@/lib/api";
import { toast } from "sonner";

export default function SupportPage() {
  const [form, setForm] = useState({ requested_username: "", contact: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!form.contact.trim() || !form.message.trim()) {
      toast.error("Заполните контакт и сообщение");
      return;
    }
    setBusy(true);
    try {
      await submitSupport(form);
      setSent(true);
      toast.success("Сообщение отправлено. Мы ответим как только сможем.");
    } catch {
      toast.error("Не удалось отправить. Попробуйте позже.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] max-w-xl mx-auto px-4 py-8 lg:py-14" data-testid="support-page">
      <Link to="/" className="inline-flex items-center gap-1.5 text-[11px] font-mono text-zinc-500 hover:text-white mb-4">
        <ArrowLeft className="w-3 h-3" /> На главную
      </Link>
      <h1 className="font-display text-2xl tracking-wider mb-1">СВЯЗАТЬСЯ С НАМИ</h1>
      <p className="text-xs font-mono text-zinc-500 mb-6">
        Опишите вопрос — ответим в Telegram или по указанному вами контакту.
      </p>

      {sent ? (
        <div className="border border-emerald-900/50 bg-emerald-950/20 p-6 text-center space-y-3" data-testid="support-sent">
          <p className="text-base text-white">✓ Сообщение отправлено</p>
          <p className="text-xs font-mono text-zinc-400">Мы свяжемся с вами в течение дня по указанному контакту.</p>
          <Link to="/" className="inline-block mt-2 px-4 h-10 leading-10 bg-white text-black text-xs font-display font-bold uppercase tracking-wider">
            ВЕРНУТЬСЯ
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4" data-testid="support-form">
          <div>
            <label className="text-[11px] font-mono text-zinc-400 uppercase tracking-wider">Логин аккаунта (если восстанавливаете доступ)</label>
            <input value={form.requested_username} onChange={(e) => setForm({ ...form, requested_username: e.target.value })}
              className="w-full mt-1 bg-zinc-900 border border-zinc-800 h-12 px-3 text-white text-sm focus:outline-none focus:border-zinc-600"
              placeholder="например: john_doe (необязательно)"
              data-testid="support-username" />
          </div>
          <div>
            <label className="text-[11px] font-mono text-zinc-400 uppercase tracking-wider">Ваш контакт *</label>
            <input value={form.contact} onChange={(e) => setForm({ ...form, contact: e.target.value })}
              className="w-full mt-1 bg-zinc-900 border border-zinc-800 h-12 px-3 text-white text-sm focus:outline-none focus:border-zinc-600"
              placeholder="@telegram, телефон или email"
              data-testid="support-contact" required />
          </div>
          <div>
            <label className="text-[11px] font-mono text-zinc-400 uppercase tracking-wider">Сообщение *</label>
            <textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
              rows={6}
              className="w-full mt-1 bg-zinc-900 border border-zinc-800 p-3 text-white text-sm focus:outline-none focus:border-zinc-600 resize-none"
              placeholder="Опишите ваш вопрос. Например: забыл пароль от аккаунта, какие заказы я делал..."
              data-testid="support-message" required />
          </div>
          <button type="submit" disabled={busy}
            className="w-full h-12 bg-white text-black font-display text-sm font-bold uppercase tracking-wider hover:bg-zinc-200 transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
            data-testid="support-submit">
            <Send className="w-4 h-4" />
            {busy ? "ОТПРАВКА..." : "ОТПРАВИТЬ"}
          </button>
          <p className="text-[11px] font-mono text-zinc-500 text-center pt-2">
            Восстановление доступа: укажите логин и опишите 1-2 ваших последних заказа, чтобы мы могли подтвердить ваше владение аккаунтом.
          </p>
        </form>
      )}
    </div>
  );
}
